import { apiClient, post } from './client';

export interface TokenPair {
  access: string;
  refresh: string;
}

export interface ChangePasswordPayload {
  current_password: string;
  new_password: string;
}

/** Authenticated self-service password change; returns a fresh JWT pair. */
export async function changeOwnPassword(body: ChangePasswordPayload): Promise<TokenPair> {
  return post<TokenPair>('/auth/change-password/', body);
}

/**
 * Staff/admin login — backed by SimpleJWT view at `/auth/api/token/`.
 * Documented in `src/authentication/urls.py` (UsernamePasswordTokenObtainPairView).
 */
export async function loginWithPassword(username: string, password: string): Promise<TokenPair> {
  return post<TokenPair>('/auth/api/token/', { username, password });
}

export interface RefreshResponse {
  access: string;
  refresh?: string;
}
export async function refreshAccess(refresh: string): Promise<RefreshResponse> {
  return post<RefreshResponse>('/auth/verify-otp/refresh', { refresh });
}

export async function logoutOnServer(refresh: string): Promise<void> {
  // Backend logout view blacklists the refresh + marks rider/packer offline.
  await apiClient.post('/auth/logout', { refresh }).catch(() => {
    /* logout is best-effort; we always clear locally regardless */
  });
}
